import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";

import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { employee_list_details } from "../../../core/data/json/employees_list_details";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "./employeeSuccess";
import "./index.css";
import {
  createNewNationals,
  getAllNationals,
  updateNationals,
} from "../../../apis/nationals";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { ChangeStatus, uploadFile } from "../../../apis/auth";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import Newloader from "./loader";
import { formatDate } from "../../../environment";
type PasswordField = "password" | "confirmPassword";

const EmployeeList = () => {
  const initialValues = {
    full_name: "",
    user_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    prefix_code: "",
    company: "",
    about: "",
    gst_no: "",
    company_name: "",
    geo_location: "",
  };
  const addressState = {
    addressLine: "",
    city: "",
    states: "",
    country: "",
    pincode: "",
  };
  const [address, setAddress] = useState(addressState);
  const { city, states, country, pincode, addressLine } = address;

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [selectedmaster, setSelectedMaster] = useState<any>();
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [statusChange, setStatusChange] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");

  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const [error, setError] = useState<string>("");
  const {
    full_name,
    user_name,
    email,
    gst_no,
    company_name,
    password,
    confirm_password,
    phone_number,
  } = formData;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Optional chaining to handle undefined cases

    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handleSelect = (item: any) => {
    setSelectedOption(item);
  };
  const handleSelectMaster = (item: any) => {
    setSelectedMaster(item);
  };
  const optionNat = [{ value: "master", label: "Master" }];
  const optionmat = [{ value: "paybia finance", label: "VITALFLOW MICRO CARE FOUNDATION" }];
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };
  type EmployeeResponse = {
    profile_pic: any;
    full_name: string;
    address: any;
    gst_number: string;
    company_name: string;
    Image: string;
    email: string;
    phone_number: string;
    geo_location: string;
    user: any;
    createdAt: string;
    Status: string;
    id: any;
  };

  type EmployeeData = {
    CreatedAt: string | number | Date;
    key: string;
    Name: string;
    Image: string;
    Email: string;
    Phone: string;
    JoiningDate: string;
    gst_no: string;
    geo_location: string;
    company_name: string;
    address: any;
    Status: string;
    id: any;
    allDetails: any;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllNationals(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id,
          CreatedAt: formatDate(item.createdAt),
          company_name: `${item?.company_name}` || "N/A",
          Name: `${item?.full_name}`,
          Email: item?.email || "Not Assigned",
          Phone: item?.phone_number || "Not Assigned",
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          gst_no: `${item?.gst_number}` || "N/A",
          Image: item?.profile_pic ? item?.profile_pic : "dummy",
          Status: item?.user?.status || "Not Assigned",
          allDetails: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    setStatusChange(true);
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };
  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: EmployeeData, b: EmployeeData) => a.key.localeCompare(b.key),
    },
    {
      title: "Date",
      dataIndex: "CreatedAt",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        new Date(a.CreatedAt).getTime() - new Date(b.CreatedAt).getTime(),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      render: (text: string) => text,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{"VITALFLOW MICRO CARE FOUNDATION"}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{"Master"}</div>
          </p>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => (
        <span className="dropdown">
          <div
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </div>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record.allDetails.user_id,
                    status: "Active",
                  })
                }
              >
                Active
              </div>
            </li>
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record.allDetails.user_id,
                    status: "InActive",
                  })
                }
              >
                InActive
              </div>
            </li>
          </ul>
        </span>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="action-icon d-inline-flex">
          <div
            style={{ cursor: "pointer" }}
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#login_modal"
            onClick={() => login(record)}
          >
            <i className="fas fa-sign-in-alt" />
          </div>
          <div
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
            onClick={() => handleEdit(record?.allDetails)}
          >
            <i className="ti ti-edit" />
          </div>
          <Link
            to={`/nationaldata?national_id=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];
  const [recordData, SetRecordData] = useState<any>();
  const [edit, setEdit] = useState(false);
  const [id, setId] = useState<number | null>(null);
  const handleEdit = (data: any) => {
    setEdit(true);
    setId(data?.id);
    const parsedAddress = JSON.parse(data.address || {});
    setFormData((prevFormData) => ({
      ...prevFormData,
      full_name: data?.full_name,
      email: data?.email,
      phone_number: data?.phone_number,
      gst_no: data?.gst_number,
      company_name: data?.company_name,
    }));
    setAddress({
      addressLine: parsedAddress?.addressLine,
      city: parsedAddress?.city,
      states: parsedAddress?.states,
      country: parsedAddress?.country,
      pincode: parsedAddress?.pincode,
    });
  };
  const login = (data: any) => {
    SetRecordData(data);
  };
  const handleSubmitLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const loginData = sessionStorage.getItem("info");
    if (loginData) {
      localStorage.setItem("info", loginData);
      let change = "change";
      sessionStorage.setItem("changing", change);
    }
    const payload = {
      id: recordData?.allDetails?.id,
      type: recordData?.allDetails?.type,
      user_id: recordData?.allDetails?.user_id,
      username: recordData?.allDetails?.full_name,
    };
    sessionStorage.setItem("info", JSON.stringify(payload));
    window.location.href = "/index";
  };
  const handleSubmitStatus = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await ChangeStatus(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `User Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (password !== confirm_password) {
      errorAlert("password and confirm password should be the same");
      return;
    }
    const requiredFields = [
      "email",
      "full_name",
      "password",
      "phone_number",
      "user_name",
      "company_name",
      "gst_no",
    ];
    const editRequiredFields = [
      "email",
      "full_name",
      "phone_number",
      "company_name",
    ];

    const editedCheck = edit ? editRequiredFields : requiredFields;
    const emptyFields = editedCheck.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }
    setLoader(true);
    const payload = {
      profile_pic: imageUrl,
      address: address,
      email: formData.email,
      full_name: formData.full_name,
      geo_location: { geolocaton: "geo_location" },
      password: formData.password,
      phone_number: formData.phone_number,
      prefix_code: formData.company_name,
      user_name: formData.user_name,
      company_name: formData.company_name,
      gst_number: formData.gst_no,
      type: "national",
    };

    try {
      if (!edit) {
        const response = await createNewNationals(payload);
        if (response.status === true) {
          successAlert("Success", "Successfully created");
          fetchAllEmployees();
          setSuccessCreation(true);
          setImage(null);
          setFormData(initialValues);
          setAddress(addressState);
        }
      } else {
        const payloads = {
          profile_pic: imageUrl,
          address: address,
          email: formData.email,
          full_name: formData.full_name,
          geo_location: { geolocaton: "geo_location" },
          phone_number: formData.phone_number,
          company_name: formData.company_name,
          gst_number: formData.gst_no,
          type: "national",
        };
        const response = await updateNationals(id, payloads);
        if (response.status === true) {
          successAlert("Success", "Successfully updated");
          fetchAllEmployees();
          setEdit(false);
          setId(null);
          setFormData(initialValues);
          setAddress(addressState);
        }
      }
    } catch (error) {
      errorAlert("error", `${error}`);
    } finally {
      setLoader(false);
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "National");
    XLSX.writeFile(workbook, "National List.xlsx");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content" style={{ background: "#0000000f" }}>
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setFormData(initialValues);
                    setAddress(addressState);
                    setEdit(false);
                    setImage(null);
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New National
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div
                className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
                style={{
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedOption ? selectedOption.label : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {optionNat.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedmaster ? selectedmaster.label : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {optionmat.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleSelectMaster(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                        <div
                          onClick={exportToPDF}
                          className="btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </div>
                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData} // Use filtered data
                    columns={columns}
                    Selection={true}
                  />
                ) : (
                  <p>No results found</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New National</h4>
                {/* <span>Nationals ID : EMP -0024</span> */}
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    {" "}
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>

                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="full_name"
                            required
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            required
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            required
                            name="phone_number"
                            value={phone_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Prefix Code <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="prefix_code"
                            value={prefix_code}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Company Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="text"
                            name="company_name"
                            value={company_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                user_name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                required
                                name="user_name"
                                value={user_name}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Password <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.password
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  required
                                  name="password"
                                  value={password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.password
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Confirm Password{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  required
                                  name="confirm_password"
                                  value={confirm_password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Gst No <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="gst_no"
                            required
                            value={gst_no}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address Line <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="addressLine"
                            value={addressLine}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="city"
                            required
                            value={city}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="text"
                            name="states"
                            value={states}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="country"
                            value={country}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            PinCode <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="pincode"
                            value={pincode}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Geo Location<span className="text-danger"> *</span>
                          </label>
                          <LocationSelector />
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      // onClick={handleSubmit}
                      // data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="login_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Login</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitLogin}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to login</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Login{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default EmployeeList;
